export class LastReflection {
  constructor(public id?: number, public day?: string, public time?: string, public exactTime?: Date) {
    if (!id) {
      this.id = 1;
    }
    this.day = day;
    this.time = time;
    this.exactTime = exactTime;
  }

  get isNotNull() {
    return this.day && this.time;
  }
}
